import axios from "axios";
import { AuthService } from ".";
import { ApiRootConstants } from "../_constants/index";

const constants = {
  api: `${ApiRootConstants.venueManagementApiRoot}api/VenueTicketMaster`,
};

const authService = new AuthService();

async function axiosConfig() {
  const user = await authService.getUser();
  if (user?.access_token) {
    const config = {
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + user.access_token,
        ContentType: "multipart/form-data",
      },
    };

    return config;
  }
}

function axiosErrHandler(error) {
  console.error(error);
  if (error.response) {
    if (error.response.status === 401) {
      throw new Error("User is not logged in");
    } else if (error.response.status === 422) {
      throw new Error(error.response.data.message);
    }
  }

  throw error;
}

export async function axiosGet(url) {
  const config = await axiosConfig();
  if (config) {
    return await axios
      .get(`${constants.api}/${url}`, config)
      .catch(error => axiosErrHandler(error));
  }
}

export async function axiosPut(url, data) {
  const config = await axiosConfig();
  if (config) {
    return await axios
      .put(`${constants.api}/${url}`, data, config)
      .catch(error => axiosErrHandler(error));
  }
}


export function getTicketMasterApiSettings(venueId) {
  return axiosGet(`GetApiSettings/${venueId}`);
}

export function updateTicketMasterApiSettings(settings) {
  return axiosPut('UpdateApiSettings', settings);
}
